import React, { useRef, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useToast } from '@chakra-ui/react'

import { Page, PageHeader, ButtonSave, ButtonCancel } from 'components'

import { FormEditForm } from '../components'
import { useFormDetailQuery, useFormCreateMutation, useFormUpdateMutation } from '../hooks'

export const FormEditPage = ({ isCreate = false, ...props }) => {
  const ref = useRef()
  const toast = useToast()
  const navigate = useNavigate()
  const { formId } = useParams()
  const [formCreate] = useFormCreateMutation()
  const [formUpdate] = useFormUpdateMutation()
  const form = useFormDetailQuery(formId, { skip: isCreate })

  const handleBack = useCallback(() => navigate('..'), [navigate])
  const handleSave = useCallback(() => ref.current.submit(), [ref])
  const handleCancel = useCallback(() => navigate('..'), [navigate])

  const handleCreate = useCallback(
    async form => {
      const { data } = await formCreate({ variables: { form } })
      if (data?.errors?.length) {
        console.error(data.errors) // @TODO
        toast({
          status: 'error',
          title: 'Erro ao criar questionário.',
          description: 'Ocorreu um erro a criar questionário'
        })
      } else {
        toast({
          status: 'success',
          title: 'Questionário criado.',
          description: 'O questionário foi criado com sucesso.'
        })
        navigate(`../${data.id}`)
      }
    },
    [toast, navigate, formCreate]
  )

  const handleUpdate = useCallback(
    async form => {
      const { data } = await formUpdate({ variables: { form, formId } })
      if (data?.errors?.length) {
        console.error(data.errors) // @TODO
        toast({
          status: 'error',
          title: 'Erro ao editar questionário.',
          description: 'Ocorreu um erro ao editar questionário'
        })
      } else {
        toast({
          status: 'success',
          title: 'Questionário editado.',
          description: 'O questionário foi editado com sucesso.'
        })
        navigate(`..`)
      }
    },
    [toast, navigate, formId, formUpdate]
  )

  return (
    <Page>
      <PageHeader
        onBack={handleBack}
        heading={isCreate ? 'Criar Questionário' : `Editar Questionário #${formId}`}>
        <ButtonSave onClick={handleSave} />
        <ButtonCancel onClick={handleCancel} />
      </PageHeader>
      <FormEditForm
        ref={ref}
        data={form.data}
        isLoading={form.loading}
        onSubmit={isCreate ? handleCreate : handleUpdate}
      />
    </Page>
  )
}

export default FormEditPage
